// extracted by mini-css-extract-plugin
module.exports = {"table-for-translation":"table-for-translation___3gQWv","tableForTranslation":"table-for-translation___3gQWv"};